import { render, staticRenderFns } from "./mealGoods.vue?vue&type=template&id=2346037a&scoped=true&"
import script from "./mealGoods.vue?vue&type=script&lang=js&"
export * from "./mealGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2346037a",
  null
  
)

export default component.exports